module.exports = __webpack_public_path__ + "img/960117a.png";